import LoginService from '@/application/services/Login'
import Util from '@/application/libs/util'
import permissionManager from '@/application/libs/permissionManager'
import eventModule from '@/application/libs/eventModule'
import InitialForm from '@/components/src/InitialForm'
import md5 from 'md5'

export default {
    /**
     * Call LoginService to do login with
     * form's data.
     * 
     * @param {String} username 
     * @param {String} password 
     */
    doLogin: function(username, password){
        return LoginService.doLogin(username, md5(password)).then(()=>{
            const permissions = permissionManager.getMenuAccess();
            let firstRoute = 'restrictions';
            if(!permissions['/restrictions']){
                let avaliableRoute = Object.keys(permissions).find(e => permissions[e]);
                firstRoute = avaliableRoute || firstRoute;
            }
            this.$router.push(firstRoute).then(function(){
                localStorage.setItem('activeScreen', 'firstRoute');

                const {CDOPERADOR} = Util.getLocalVar('userData');
                const oldFilterData = sessionStorage.getItem('oldFilterData');
                sessionStorage.removeItem('oldFilterData');
                if(oldFilterData && oldFilterData.CDOPERADOR === CDOPERADOR){
                    const boData = Util.getFilterInSession();
                    const {CDFILIAL, NMFILIAL, CDSERVFILI, NMSERVICO, TPCONTRATO, NMCONTRATO, DTMESCARD} = oldFilterData;
                    const newBoData = {...boData, CDFILIAL, NMFILIAL, CDSERVFILI, NMSERVICO, TPCONTRATO, NMCONTRATO, DTMESCARD};
                    Util.setLocalVar('backOfficeData', newBoData);
                    sessionStorage.setItem('filterData', JSON.stringify(newBoData));
                    eventModule.$emit('updateBoData', {oldValue: {}, newValue: newBoData});
                }
            }.bind(this));
        });
    },

    isLogged: function(){
        return LoginService.isLogged();
    },

    hasSystemToken(){
        return Util.getLocalVar('backoffice_token');
    }
}